import Badge from "components/lib/Shared/Badge";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { twMerge } from "tailwind-merge";

function SidebarItem({ item, selectedTab, handleTabClick = () => null }) {
  const { company = {} } = useSelector((state) => state.companySlice);
  let link = "";
  let initiator = {};
  if (company?.transferYourBusinessInitiator?.company) {
    initiator = company?.transferYourBusinessInitiator?.company;
    link = `/companies/${initiator._id}/dashboard?${item.id}`;
  }
  if (company?.transferYourBusinessInitiator?.corporate) {
    initiator = company?.transferYourBusinessInitiator?.corporate;
    link = `/corporates/${initiator._id}/dashboard?${item.id}`;
  }
  return (
    <Link to={link}>
      <li
        key={item.label}
        className={twMerge(
          item.id === selectedTab.id ? "text-primary" : "text-gray-400",
          `mb-3 font-medium ${
            item.disabled
              ? "cursor-not-allowed text-gray-300/95"
              : "hover:text-sflPrimary cursor-pointer"
          }`
        )}
        onClick={() => handleTabClick(item)}
      >
        <span className="">{item.label}</span>{" "}
        {item.comingSoon && (
          <Badge
            bgColor="bg-blue-200"
            textColor="text-gray-700"
            text={"Coming Soon"}
            className={
              "inline-flex absolute ml-1 items-center rounded-full bg-blue-50 px-1 py-0.5 text-xxs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10"
            }
          />
        )}
      </li>
    </Link>
  );
}

export default SidebarItem;
